import moment from 'moment';
import {
    chartChartConfig,
    chartCommonConfig,
    chartTitleConfig,
    chartYaxisConfig,
    chartLineXaxisConfig,
    axisLablesFontSizeSet
  } from '../../config/chartCommon';
import { roundToTwoDecimal } from '../../utilities/common.computations';
  
  function heatmapAirQualityConfig({
    chartApiData,
    userAccessibility,
    graphFilter,
    heatmapChartValues,
    graphName}) {

  const getIndicatorName = (value) =>{
    const indicator = heatmapChartValues?.range.filter(category => value >= category.from && (value < category?.to || category.to === undefined))[0];
    return indicator ? indicator.name : '';
  }      
  const config = {
    ...chartTitleConfig({
      graphTitle: graphName,
      userAccessibility: userAccessibility,
    }),
    ...chartCommonConfig,
    chart: {
      ...chartChartConfig({ userAccessibility: userAccessibility }),
      type: 'heatmap',
      spacingBottom: 35,
    },
    ...chartLineXaxisConfig({ graphFilter: graphFilter, userAccessibility: userAccessibility }),

    ...chartYaxisConfig({ userAccessibility }),
    yAxis: {
        categories: chartApiData.equipment_names,
        title: null,
    },
    legend: {
      enabled: true,
      align: 'center',
      verticalAlign: 'bottom',
      floating: true,
      y: 40,
      itemStyle: {
        fontWeight: 'lighter',
        fontSize: axisLablesFontSizeSet(userAccessibility)
      },
    
    },
   
    tooltip: {
        // valueSuffix: chartApiData.unit_name ? ` ${chartApiData.unit_name}` : ' kW',
        // valueDecimals: 2,
        borderWidth: 1,
        useHTML: true,
        formatter: function () {
          console.log("this.poi", this.point)
          let name = `<div>${this.series.yAxis.categories[this.point.y]}</div>`
          let value = `${heatmapChartValues.value_name
          }:</div> <span>${roundToTwoDecimal(this.point.value)} ${
              heatmapChartValues.unit
          }`
          let value_name = `<div class="semi-bold">${ getIndicatorName(this.point.value)} </div>`
          let time = `<div>${moment(this.point.x).format('DD MMM, HH:mm')
        } 
        <div>` 
          if (this.point.value !== null && this.point.value !== undefined && !isNaN(this.point.value) && this.point.value >= 0) {
            return `${name}${value}${value_name}${time}
`
          }
          else {
            return `${name}<div>No data</div>${time}
          `
          }
            // return this.point.value ? `${name}${value}${value_name}${time}
            // ` : `${name}<div>No data</div>${time}
            // ` ;
          }
      },
  colorAxis: {
      dataClasses: heatmapChartValues?.range
      ,
    
  },
    series: [
  
      {
         //    boostThreshold: 100,
             pointPadding: 0,
            data: chartApiData.length == 0 ? [] : chartApiData && chartApiData.data_points,
            colsize: chartApiData.point_interval,
        //    showInLegend: true,

      },
      
    ]
  };
  return config;
  }
  
  
  
  export default heatmapAirQualityConfig;
  